'use strict';

(function () {
    'use strict';

    angular.module('zp').config(['$stateProvider', '$urlRouterProvider', '$locationProvider', function ($stateProvider, $urlRouterProvider, $locationProvider) {
        $locationProvider.html5Mode({
            enabled: true,
            requireBase: false
        });

        $stateProvider.state('nav', {
            templateUrl: 'app/nav/nav.html',
            controller: 'navController',
            controllerAs: 'vm'
        }).state('nav.main', {
            url: '/',
            templateUrl: 'app/home/home.html',
            controller: 'homeController',
            controllerAs: 'vm',
            data: {
                meta_type: 'text',
                meta: {
                    'title': 'Sve za vase vencanje na jednom mestu | Ludi Kamen',
                    'og:title': 'Sve za vase vencanje na jednom mestu | Ludi Kamen',
                    'twitter:title': 'Sve za vase vencanje na jednom mestu | Ludi Kamen',
                    'description': 'Ukoliko trazite prostore za vencanje ili restorane za svadbu ili vase vencanje na pravom ste mestu. Sajt Ludi kamen vam nudi veliki izbor bendova za vencanje, kao i najlepse vencanice za svadbu i vencanja. Takodje, imamo veliki izbor verenickog prstenja i burmi za svaciji ukus, kao i mladenacke i svadbene torte po vasoj zelji. Fotografi za vencanja, momacko vece i devojacko vece, kao i bidermajeri nalaze se na nasem sajtu Ludi kamen. Ovde mozete naci i limuzine za vencanje. Veliki je i izbor destinacija za medeni mesec.',
                    'og:description': 'Ukoliko trazite prostore za vencanje ili restorane za svadbu ili vase vencanje na pravom ste mestu. Sajt Ludi kamen vam nudi veliki izbor bendova za vencanje, kao i najlepse vencanice za svadbu i vencanja. Takodje, imamo veliki izbor verenickog prstenja i burmi za svaciji ukus, kao i mladenacke i svadbene torte po vasoj zelji. Fotografi za vencanja, momacko vece i devojacko vece, kao i bidermajeri nalaze se na nasem sajtu Ludi kamen. Ovde mozete naci i limuzine za vencanje. Veliki je i izbor destinacija za medeni mesec.',
                    'twitter:description': 'Ukoliko trazite prostore za vencanje ili restorane za svadbu ili vase vencanje na pravom ste mestu. Sajt Ludi kamen vam nudi veliki izbor bendova za vencanje, kao i najlepse vencanice za svadbu i vencanja. Takodje, imamo veliki izbor verenickog prstenja i burmi za svaciji ukus, kao i mladenacke i svadbene torte po vasoj zelji. Fotografi za vencanja, momacko vece i devojacko vece, kao i bidermajeri nalaze se na nasem sajtu Ludi kamen. Ovde mozete naci i limuzine za vencanje. Veliki je i izbor destinacija za medeni mesec.',
                    'keywords': 'Restorani za svadbe, prostori za vencanja, vencanja restorani, svadbeni prostori, muzika za svadbu, bendovi, organizacija vencanja, dekoracija vencanja, fotografi za vencanje, bidermajeri, mladenacko prestenje, burma, burme, haljine za vencanja, vencanice, svadbene haljine, svadbeni obicaji, obicaji na vencanju, momacko vece, devojacko vece, limuzine, medeni mesec, spa centri, svadbena torta, torta na vencanju, mladenacka torta, cena stolice svadba'
                }
            }
        }).state('sitemap', {
            url: '/lk/sitemap',
            templateUrl: 'app/sitemap/sitemap.html',
            controller: 'sitemapController',
            controllerAs: 'vm'
        }).state('nav.shop', {
            url: '/prodavnica',
            templateUrl: 'app/shop/shop.html',
            controller: 'ShopController',
            controllerAs: 'vm',
            data: {
                meta_type: 'text',
                meta: {
                    'title': 'Ludi Kamen - Obogatite vaše venčanje sitnicama iz naše prodavnice',
                    'og:title': 'Ludi Kamen - Obogatite vaše venčanje sitnicama iz naše prodavnice',
                    'twitter:title': 'Ludi Kamen - Obogatite vaše venčanje sitnicama iz naše prodavnice'
                }
            }
        }).state('nav.shop-item', {
            url: '/prodavnica/:name',
            templateUrl: 'app/shop/shop.item.html',
            controller: 'ShopItemController',
            controllerAs: 'vm',
            data: {
                meta_type: 'template',
                meta: {
                    'title': 'Ludi Kamen - Organizacija Venčanja - Prodavnica - {{name}}',
                    'og:title': 'Ludi Kamen - Organizacija Venčanja - Prodavnica - {{name}}',
                    'twitter:title': 'Ludi Kamen - Organizacija Venčanja - Prodavnica - {{name}}'
                }
            }
        }).state('nav.mixes', {
            url: '/miksevi',
            templateUrl: 'app/mixes/mixes.html',
            controller: 'MixesController',
            controllerAs: 'vm',
            data: {
                meta_type: 'text',
                meta: {
                    'title': 'Predlazemo ideje za najlepsi dan i Vase vencanje | Ludi Kamen',
                    'og:title': 'Predlazemo ideje za najlepsi dan i Vase vencanje | Ludi Kamen',
                    'twitter:title': 'Predlazemo ideje za najlepsi dan i Vase vencanje | Ludi Kamen',
                    'description': 'Pogledajte neko od nasih kombinacija koje smo osmislili za Vas kako bismo olaksili Vas izbor i odabir prostora za vencanje, muzike za vencanje, vencanice, burmi i torte.',
                    'og:description': 'Pogledajte neko od nasih kombinacija koje smo osmislili za Vas kako bismo olaksili Vas izbor i odabir prostora za vencanje, muzike za vencanje, vencanice, burmi i torte.',
                    'twitter:description': 'Pogledajte neko od nasih kombinacija koje smo osmislili za Vas kako bismo olaksili Vas izbor i odabir prostora za vencanje, muzike za vencanje, vencanice, burmi i torte.',
                    'keywords': 'Ideja za vencanje, organizacija vencanja, organizacija svadbi, kako organizovati svadbu, kako organizovati vencanje'
                }
            }
        }).state('nav.mix-item', {
            url: '/miksevi/:alias',
            templateUrl: 'app/mixes/mix.item.html',
            controller: 'MixItemController',
            controllerAs: 'vm',
            data: {
                meta_type: 'template',
                meta: {
                    'title': '{{alias:title}} | Ludi Kamen',
                    'og:title': '{{alias:og:title}} | Ludi Kamen',
                    'twitter:title': '{{alias:twitter:title}} | Ludi Kamen',
                    'description': '{{alias:description}}',
                    'og:description': '{{alias:og:description}}',
                    'twitter:description': '{{alias:twitter:description}}',
                    'keywords': '{{alias:keywords}}'
                }
            }
        }).state('nav.mix-user', {
            url: '/moj-miks',
            templateUrl: 'app/mixes/mix.user.html',
            controller: 'mixUserController',
            controllerAs: 'vm',
            data: {
                meta_type: 'text',
                meta: {
                    'title': 'Vase ideje za najlepsi dan i Vase vencanje | Ludi Kamen',
                    'og:title': 'Vase ideje za najlepsi dan i Vase vencanje | Ludi Kamen',
                    'twitter:title': 'Vase ideje za najlepsi dan i Vase vencanje | Ludi Kamen',
                    'description': 'Vase kombinacije koje ste osmislili',
                    'og:description': 'Vase kombinacije koje ste osmislili',
                    'twitter:description': 'Vase kombinacije koje ste osmislili',
                    'keywords': 'Ideja za vencanje, organizacija vencanja, organizacija svadbi, kako organizovati svadbu, kako organizovati vencanje'
                }
            }
        }).state('nav.honey-moon', {
            url: '/medeni-mesec/:destination?',
            templateUrl: 'app/map/map.honey.moon.html',
            controller: 'MapHoneyMoonController',
            controllerAs: 'vm',
            data: {
                meta_type: 'text',
                meta: {
                    'title': 'Izaberiti neke od najlepsih i najromanticnijih destinacija za Vas medeni mesec | Ludi Kamen',
                    'og:title': 'Izaberiti neke od najlepsih i najromanticnijih destinacija za Vas medeni mesec | Ludi Kamen',
                    'twitter:title': 'Izaberiti neke od najlepsih i najromanticnijih destinacija za Vas medeni mesec | Ludi Kamen',
                    'description': 'Portal Ludi kamen Vam nudi ideje za neke od najegzoticnijih i najromanticnijih destinacija za Vas medeni mesec.',
                    'og:description': 'Portal Ludi kamen Vam nudi ideje za neke od najegzoticnijih i najromanticnijih destinacija za Vas medeni mesec.',
                    'twitter:description': 'Portal Ludi kamen Vam nudi ideje za neke od najegzoticnijih i najromanticnijih destinacija za Vas medeni mesec.',
                    'keywords': 'Medeni mesec, romanticne destinacije, romanticna putovanja, kuda za medeni mesec, ideja za medeni mesec'
                }
            }
        }).state('nav.posts', {
            url: '/inspiracije',
            templateUrl: 'app/posts/posts.html',
            data: {
                meta_type: 'text',
                meta: {
                    'title': 'Pogledajte neke od najboljih ideja i saveta za Vase vencanje | Ludi Kamen',
                    'og:title': 'Pogledajte neke od najboljih ideja i saveta za Vase vencanje | Ludi Kamen',
                    'twitter:title': 'Pogledajte neke od najboljih ideja i saveta za Vase vencanje | Ludi Kamen',
                    'description': 'Inspiracije na portalu Ludi kamen Vam nude najraznovrsniji izbor ideja i saveta koji ce Vam olaksati organizaciju vencanja i omoguciti da se pripremite i uzivate u najradosnijem danu',
                    'og:description': 'Inspiracije na portalu Ludi kamen Vam nude najraznovrsniji izbor ideja i saveta koji ce Vam olaksati organizaciju vencanja i omoguciti da se pripremite i uzivate u najradosnijem danu',
                    'twitter:description': 'Inspiracije na portalu Ludi kamen Vam nude najraznovrsniji izbor ideja i saveta koji ce Vam olaksati organizaciju vencanja i omoguciti da se pripremite i uzivate u najradosnijem danu',
                    'keywords': 'Ideje za vencanje, inspiracije za vencanje, inspiracije za svadbu, ideje za svadbu, saveti za vencanje, saveti za svadbu'
                }
            }
        }).state('nav.post-item', {
            url: '/inspiracije/:alias',
            templateUrl: 'app/posts/post.item.html',
            controller: 'PostItemController',
            controllerAs: 'vm',
            data: {
                meta_type: 'template',
                meta: {
                    'title': '{{alias:title}} | Ludi Kamen',
                    'og:title': '{{alias:og:title}} | Ludi Kamen',
                    'twitter:title': '{{alias:twitter:title}} | Ludi Kamen',
                    'description': '{{alias:description}}',
                    'og:description': '{{alias:og:description}}',
                    'twitter:description': '{{alias:twitter:description}}',
                    'keywords': '{{alias:keywords}}'
                }
            }
        }).state('nav.vendor-slug', {
            url: '/:vendor/:slugCity/:slugName',
            templateUrl: 'app/vendors/vendor.html',
            controller: 'VendorController',
            controllerAs: 'vm',
            data: {
                meta_type: 'template',
                meta: {
                    'title': '{{slugName}} - {{slugCity}} - {{vendor:title}} | Ludi Kamen',
                    'og:title': '{{slugName}} - {{slugCity}} - {{vendor:og:title}} | Ludi Kamen',
                    'twitter:title': '{{slugName}} - {{slugCity}} - {{vendor:twitter:title}} | Ludi Kamen',
                    'description': 'Najbolji izbor iz kategorije {{vendor}} za vencanje mozete pogledati na sajtu Ludi kamen. Iz kompletne ponude izdvajamo, posebno za vaše venčanje, {{slugName}} {{slugCity}}, iz kategorije {{vendor}}.',
                    'og:description': 'Najbolji izbor iz kategorije {{vendor}} za vencanje mozete pogledati na sajtu Ludi kamen. Iz kompletne ponude izdvajamo, posebno za vaše venčanje, {{slugName}} {{slugCity}}, iz kategorije {{vendor}}.',
                    'twitter:description': 'Najbolji izbor iz kategorije {{vendor}} za vencanje mozete pogledati na sajtu Ludi kamen. Iz kompletne ponude izdvajamo, posebno za vaše venčanje, {{slugName}} {{slugCity}}, iz kategorije {{vendor}}.',
                    'keywords': '{{vendor:keywords}}'
                }
            }
        }).state('nav.results', {
            url: '/:vendor',
            templateUrl: 'app/results/results.html',
            controller: 'resultsController',
            controllerAs: 'vm',
            params: {
                city: null
            },
            data: {
                meta_type: 'template',
                meta: {
                    'title': '{{vendor:title}} | Ludi Kamen',
                    'og:title': '{{vendor:og:title}} | Ludi Kamen',
                    'twitter:title': '{{vendor:twitter:title}} | Ludi Kamen',
                    'description': '{{vendor:description}}',
                    'og:description': '{{vendor:og:description}}',
                    'twitter:description': '{{vendor:twitter:description}}',
                    'keywords': '{{vendor:keywords}}'
                }
            }
        });

        $urlRouterProvider.otherwise('/');
    }]);
})();